import OrganizationSettingsPage from './OrganizationSettingsPage';

export default OrganizationSettingsPage;